<div style="width: 300px;">
   <div class="d-flex mb-4" *ngFor="let item  of items; let l =last;let idx=index">
      <input [(ngModel)]="item.range" (ngModelChange)="emitValue()" class="form-control mr-3" placeholder="range">
      <input [(ngModel)]="item.marks" (ngModelChange)="emitValue()" class="form-control" placeholder="marks">
      <button class="btn" (click)="remove(idx)"><i class="fa fa-times-circle text-danger"></i></button>
      <button class="btn" (click)="addNew()" *ngIf="l"><i class="fa fa-plus-circle text-success"></i></button>
   </div>
</div>

